module.exports = __webpack_public_path__ + "img/bg.fad3abf6.webp";